import WebApi from "@/views/loyalty/shared/modules/web_api"

export class ActionEndpointService {
    constructor () {
        this.url = `${process.env.VUE_APP_NOTIF_URL}api/action/`
        console.log('url', this.url)
        this.webApi = new WebApi()
    }

    async getAll (clientId, userId) {
        const action = await this.webApi.get(`${this.url}all/${clientId}/${userId}`)
        if (!action.status_code) {
            return action
        } else {
            console.error(`Ошибка с кодом: ${action.status_code}`)
        }
    }

    async save (clientId, userId, userActions) {
        const action = await this.webApi.post(`${this.url}save/${clientId}/${userId}`, userActions)
        if (!action.status_code) {
            return action
        } else {
            console.error(`Ошибка с кодом: ${action.status_code}`)
        }
    }
}
